import { Box, Button, Icon, InputLabel, Stack, Typography } from "@mui/material";
import { webinarResourcesSchema } from "../../../../../utils/velidations";
import InputFieldB from "../../../../../components/ui/InputFieldB";
import { Fragment, useEffect, useRef, useState } from "react";
import Icons from "../../../../../assets/js/Icons";
import { useSelector } from "react-redux";

function Resources({ data, setValue }) {
  const [, setResources] = useState(null);
  const [helperText, setHelperText] = useState([]);
  const files = useRef(data?.resources?.files || "");
  const { loadings } = useSelector((state) => state.otherSlice);

  useEffect(() => {
    if (data?.resources?.files && data.resources.files.length > 0) {
      files.current = data.resources.files;
    }
    // eslint-disable-next-line
  }, []);

  // Handle image preview
  const handleImagePreview = (e) => {
    files.current = Array.from(e.target.files);
    setResources(files?.current);
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    const form = new FormData(e.target);
    const formData = Object.fromEntries(form);
    formData.files = files.current || null;
    const result = webinarResourcesSchema.safeParse(formData);
    if (!result.success) {
      const groupedErrors = {};
      result.error.issues.forEach((issue) => {
        const key = issue.path[0];
        if (!groupedErrors[key]) {
          groupedErrors[key] = [];
        }
        groupedErrors[key].push(issue.message);
      });
      setHelperText(groupedErrors);
      return;
    }
    setHelperText([]);
    data.resources = formData;
    setValue("submission");
  };

  return (
    <Fragment>
      <Typography variant="typographyA">Resources</Typography>
      <Stack spacing={2} component="form" onSubmit={handleSubmit}>
        <Box>
          <InputLabel
            sx={{
              mb: 0,
              height: "100%",
              maxHeight: 300,
              borderRadius: "8px",
              border: "1px dashed",
              placeContent: "center",
              borderColor: "primary.main",
              display: "grid",
              alignContent: "center",
            }}

          >
            <>
              <Icon
                sx={{
                  fontSize: "100px",
                  color: "other.color2",
                  m: "auto",
                  svg: { display: "block" },
                }}
              >
                <Icons.UploadSolid />
              </Icon>
              <Typography mb={1.5} color="other.color2">
                Upload PDF/Doc for worksheet or presentation
              </Typography>
              {files.current && files.current.length > 0 && (
                <Typography variant="body2" color="primary">
                  {files.current.length} file(s) uploaded:{" "}
                  {files.current[0]?.name}
                </Typography>
              )}
            </>
            <input
              type="file"
              name="files"
              style={{ display: "none" }}
              onChange={handleImagePreview}
              accept=".pdf,.doc,.docx,.ppt,.pptx"
              multiple
            />
            {/*  */}
          </InputLabel>
          {helperText?.coverImage?.[0] && (
            <Typography mt={0.5} fontSize="14px" color="error.main">
              {helperText?.coverImage?.[0]}
            </Typography>
          )}
        </Box>
        <InputFieldB
          name="webinarLink"
          variant="outlined"
          label="Webinar Link *"
          helperText={helperText}
          placeholder="Enter webinar link"
          defaultValue={data?.resources?.webinarLink || ""}
        />
        <Stack direction="row" spacing={1}>
          <Button
            size="large"
            type="button"
            variant="contained"
            sx={{ minWidth: 150 }}
            disabled={loadings?.create}
            onClick={() => {
              setValue("format");
            }}
          >
            Back
          </Button>
          <Button
            size="large"
            type="submit"
            variant="contained"
            sx={{ minWidth: 150 }}
            disabled={loadings?.create}
          >
            Next
          </Button>
        </Stack>
      </Stack>
    </Fragment>
  );
}

export default Resources;
